<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-two-thirds">
        <div class="box">
          <admin-box-item title="서비스 등록">
            <!-- 선주문 테마 -->
            <div>
              <admin-form-item label="패키지 선택" desc="메뉴 구성을 위해서 패키지를 선택해주세요. 선택한 패키지는 메뉴에 반영됩니다.">
                <lp-check-group-boolean :list="allPackages" @selectedItem="selectPack"></lp-check-group-boolean>
              </admin-form-item>
              <admin-form-item label="사용자(이메일 계정)" style="margin-top:20px">
                <lp-adm-drop-input :data.sync="listUser"
                                   :selectVal="username"
                                   @onSelect="selectUser"
                                   added_field="type"
                                   placeholder="검색 후 선택"
                                   width="250px"
                                   listAlign="center"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
              </admin-form-item>

              <admin-form-item label="테마" style="margin-top:20px">
                <lp-adm-drop-input :data.sync="listTheme"
                                   :selectVal="theme"
                                   @onSelect="selectTheme"
                                   added_field="type"
                                   placeholder="검색 후 선택"
                                   width="250px"
                                   listAlign="center"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
              </admin-form-item>

              <admin-form-item label="주문전환 상품 선택" style="margin-top:20px">
                <span class="select">
                  <select v-model="order" @change="e=>selectProduct(e, 'order')">
                    <option v-for="(order,idx) in option.order"
                            :key="'order-'+idx"
                            :value="order.id">{{ order.name }}</option>
                  </select>
                </span>
              </admin-form-item>

              <admin-form-item label="문의전환 상품 선택" style="margin-top:20px">
                <span class="select">
                  <select v-model="inquiry" @change="e=>selectProduct(e, 'inquiry')">
                    <option v-for="(inquiry,idx) in option.inquiry"
                            :key="'inquiry-'+idx"
                            :value="inquiry.id">{{ inquiry.name }}</option>
                  </select>
                </span>
              </admin-form-item>

              <admin-form-item label="결제방식 상품 선택" style="margin-top:20px">
                <span class="select">
                  <select v-model="payment" @change="e=>selectProduct(e, 'payment')">
                    <option v-for="(payment,idx) in option.payment"
                            :key="'payment-'+idx"
                            :value="payment.id">{{ payment.name }}</option>
                  </select>
                </span>
              </admin-form-item>

              <admin-form-item label="회원등급 상품 선택" style="margin-top:20px">
                <span class="select">
                  <select v-model="userGrade" @change="e=>selectProduct(e, 'userGrade')">
                    <option v-for="(userGrade,idx) in option.userGrade"
                            :key="'userGrade-'+idx"
                            :value="userGrade.id">{{ userGrade.name }}</option>
                  </select>
                </span>
              </admin-form-item>

              <admin-form-item label="파트너등급 상품 선택" style="margin-top:20px">
                <span class="select">
                  <select v-model="partnerGrade" @change="e=>selectProduct(e, 'partnerGrade')">
                    <option v-for="(partnerGrade,idx) in option.partnerGrade"
                            :key="'partnerGrade-'+idx"
                            :value="partnerGrade.id">{{ partnerGrade.name }}</option>
                  </select>
                </span>
              </admin-form-item>

             <!-- <admin-form-item label="선택된 상품들" style="margin-top:20px" v-if="this.value.products.length>0">
                <div class="flex" style="flex-wrap:wrap">
                  <div v-for="(id, idx) in this.value.products" class="lp-prod-box">
                    {{ convertProductName(id) }}
                    <i class="lp-box-delete unselect material-icons" @click="deleteProduct(idx)">close</i>
                  </div>
                </div>
              </admin-form-item>-->

              <admin-form-item label="가격" style="margin-top:20px">
                <input class="input"
                       style="width:250px"
                       v-model="value.price"
                       @input="e => setNumber(e, 'price', 10)"
                       type="number">
              </admin-form-item>

              <admin-form-item label="결제 종류">
                <lp-radio :val.sync="value.pay_type" label_name="label" value_name="value" :data="listPayType"></lp-radio>
              </admin-form-item>

              <admin-form-item label="결제 방식">
                <lp-radio :val.sync="value.pay_method" label_name="label" value_name="value" :data="listPayMethod"></lp-radio>
              </admin-form-item>

              <admin-form-item label="결제 주기 (월)" style="margin-top:20px" v-if="value.pay_method===0">
                <input class="input"
                       style="width:250px"
                       v-model="value.date_unit"
                       @input="e => setNumber(e, 'date_unit', 2)"
                       type="number" maxlength="30">
              </admin-form-item>

            <!--  <admin-form-item label="다음 결제일" style="margin-top:20px" v-if="value.pay_method===0">
                <admin-date-picker
                  type="date"
                  :data="value.next_date"
                  @setDate="date => selectDate(date)"></admin-date-picker>
              </admin-form-item>-->

              <admin-form-item label="서비스명" style="margin-top:20px">
                <input class="input"
                       style="width:250px"
                       :value="value.service_name"
                       @input="e => value.service_name = e.target.value"
                       type="text" maxlength="30">
              </admin-form-item>

              <admin-form-item label="서비스 키(알파벳으로만 입력)" style="margin-top:20px">
                <input class="input"
                       :value="value.key"
                       @input="e => value.key = e.target.value"
                       style="width:140px"
                       type="text" maxlength="30"><span style="line-height:32px;margin-left:8px">.launchpack.co.kr</span>
              </admin-form-item>

              <admin-form-item label="도메인(제공받은게 있을때만 입력)" style="margin-top:20px">
                <input class="input"
                       :value="value.domain"
                       @input="e => value.domain = e.target.value"
                       type="text" maxlength="30">
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckGroupBoolean from "../../../module/common/LpCheckGroupBoolean";

  export default {
    components: {
      LpRadio,
      LpAdmDropInput,
      LpCheckGroupBoolean
    },

    data() {
      return {
        allPackages: [],
        listPayType: [
          { label: '1회결제', value: 0 },
          { label: '정기결제', value: 1 },
        ],
        listPayMethod: [
          { label: '빌링', value: 0 },
          { label: '계좌이체', value: 1 },
        ],
        listProduct: [],
        listUser: [],
        listTheme: [],
        product: '',
        username: '',
        theme: '',
        value: {
          user_id: 0,
          service_name: '',
          key: '',
          domain: '',
          theme_id: '',
          // 결제종류
          pay_type: '',
          // 결제방식
          pay_method: 0,
          date_unit: 1,
          next_date: '',
          products: [],
          price: 0,
          package: '',
          // 결제 이용방식
          payment_type: '',
          inquiry_conversion_type: '',
          order_conversion_type: '',
          plugins: [],
          request_type: 1

        },
        order: 10000,                 // 주문전환 종류
        inquiry: 10000,               // 문의전환 종류
        payment: 10000,               // 결제 종류
        userGrade: 10000,             // 회원등급 여부
        partnerGrade: 10000,
        option: {
          basic: [],
          order: [],
          inquiry: [],
          payment: [],
          userGrade: [
            {
              id: 1,
              name: '필요',
            },
            {
              id: 0,
              name: '안필요'
            }
          ],
          partnerGrade: [
            {
              id: 1,
              name: '필요',
            },
            {
              id: 0,
              name: '안필요'
            }
          ],
          plugIn: []
        }
      }
    },
    created() {
      this.getData();
      this.getThemeList();
      this.getAllPackages();
    },

    mounted() {
      this.$axios.get('public/launchpack/estimate/form').then(res=> {
        console.log(res.data)
      });
    },

    methods: {
      selectPack(res) {
        console.log(res)
      },
      getAllPackages() {
        this.$axios.get('public/service/packages/all').then(res=> {
          let packs = res.data;
          packs.forEach(pack => {
            this.allPackages.push({label: pack.name, name:pack.key, is_active: false})
          })
        })
      },
      selectProduct(e, key) {
        this[key] = parseInt(e.target.value);
      },
      setNumber(e, key, max_length) {
        if( e.target.value.length > max_length) {
          this.value[key] = parseInt(e.target.value.substr(0, max_length));
        }
        else this.value[key] = parseInt(e.target.value);
      },
      selectDate(date) {
        this.value.next_date = date;
      },
      getThemeList() {
        this.$axios.get('public/theme/whole').then(res=>{
          this.listTheme = res.data;
        });
      },
      selectTheme(res) {
        this.value.theme_id = res.value;
        this.theme = res.label;
      },
      selectUser(res) {
        this.value.user_id = res.value;
        this.username = res.label;
      },
      async getData() {
        await this.getProductList();
        await this.getUserList();
        this.getDetail();
      },
      getProductList() {
        this.$axios.get('public/launchpack/estimate/form').then(res=> {
          let cats = res.data;
          cats.forEach(cat => {
            if (cat.name === '기본') {
              this.option.basic = cat.products;
            }
            else if (cat.name === '주문전환') {
              this.option.order = cat.products;
            }
            else if (cat.name === '문의전환') {
              this.option.inquiry = cat.products;
            }
            else if (cat.name === '결제방식') {
              this.option.payment = [{id: 0, name: '안할', text: '안할'}];
              this.option.payment = this.option.payment.concat(cat.products);
            }
            // 플러그인은 예외 케이스이기 때문에 별도로 저장
            else if (cat.name === '플러그인') {
              this.option.plugIn = cat.products;
            }
          })
        })
      },
      getUserList() {
        this.$axios.get('public/user/whole').then(res=>{
          this.listUser = res.data;
        });
      },
      getDetail() {
        if(this.$route.query.service_inquiry_id) {
          this.$axios.get(this.getUrl(`launchpack/service/inquiry/${this.$route.query.service_inquiry_id}`)).then(res=>{
            for(let j=0; j<this.listUser.length; j++) {
              if(this.listUser[j].value === res.data.user) {
                this.username = this.listUser[j].label;
                this.value.user_id = res.data.user;
              }
            }
          })
        }

        else if(this.$route.query.theme_request_id) {
          this.$axios.get(this.getUrl(`launchpack/theme/request/${this.$route.query.theme_request_id}`)).then(res=>{
            for(let j=0; j<this.listUser.length; j++) {
              if(this.listUser[j].value === res.data.user) {
                this.username = this.listUser[j].label;
                this.value.user_id = res.data.user;
              }
            }
          })
        }
      },
      saveData() {
        let err = '';
        if(this.order===10000) err = '주문 전환 상품을 선택하세요';
        else if(this.inquiry===10000) err = '문의 전환 상품을 선택하세요';
        else if(this.payment===10000) err = '결제 종류 상품을 선택하세요';
        else if(this.userGrade===10000) err = '회원 등급 상품을 선택하세요';
        else if(this.partnerGrade===10000) err = '파트너 등급 상품을 선택하세요';
        else if(this.value.user_id===0) err = '사용자를 선택하세요.';
        else if(this.value.price===0) err = '가격을 선택하세요.';
        else if(this.value.service_name==='') err = '서비스명을 입력해주세요.';
        else if(this.value.key==='') err = '서비스키를 입력해주세요.';
        else if(this.value.theme_id==='') err = '테마를 선택하세요.';
        else if(this.value.pay_type==='') err = '결제종류를 선택하세요.';
        else if(this.value.pay_method==='') err = '결제방식을 선택하세요.';
        else if(this.value.pay_method!=='') {
          if(this.date_unit===0) err = '결제주기를 입력하세요.';
          else if(this.next_date==='') err = '다음결제일을 선택하세요.';
        }

        if(err){
          this.toast(err);
          return;
        }

        // 선택한 상품 처리
        this.checkProducts();

        let value = this.cloneItem(this.value);
        let packs = [];
        this.allPackages.forEach(pack=> {
          if(pack.is_active) {
            packs.push(pack.name);
          }
        })
        value.packs = packs;

        this.$store.commit('setLoading', true);
        this.$axios.post('admin/launchpack/service', value).then(res=>{
          if(res.status===200 && res.data.detail==='success'){
            this.$store.commit('setLoading', false);
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('launchpack/service'));
          }
        }).catch(error=>{
          this.$store.commit('setLoading', false);
          if(error.response.data.detail){
            this.toast(error.response.data.detail);
          }
          else {
            this.toast(error.response.data.message);
          }
        })

      },
      convertOrder(name) {
        switch (name) {
          case '없음': return 0;
          case '전화연결': return 1;
          case '아웃링크': return 2;
          case '상품배송주문': return 3;
          case '모임신청': return 4;
          case '상담신청': return 5;
          case '견적요청': return 6;
          case '사용권': return 7;
          case '컨텐츠다운로드': return 8;
        }
      },

      convertInquiry(name) {
        switch (name) {
          case '없음': return 0;
          case '전화문의': return 1;
          case '이메일문의': return 2;
          case '톡문의': return 3;
        }
      },

      convertPayment(name) {
        switch (name) {
          case '없음': return 0;
          case '결제이용': return 1;
        }
      },

      convertPack(number) {
        // 주문 전환에 맞춰서 패키지이름 매칭을 시켜야함.
        switch (number) {
          case 1: return 'call';
          case 2: return 'outlink';
          case 3: return 'delivery';
          case 4: return 'meet';
          case 5: return 'counsel';
          case 6: return 'estimate';
          case 7: return '';
          case 8: return 'commerce';
        }
      },
      checkProducts() {
        if(this.order > 0) {
          if(this.value.products.indexOf(this.order)===-1) {
            this.value.products.push(this.order);
            this.option.order.forEach(order=>{
              if(order.id === parseInt(this.order)){
                this.value.order_conversion_type = this.convertOrder(order.name);
                this.value.package = this.convertPack(this.value.order_conversion_type);
              }
            })
          }
        }
        if(this.payment===0) this.value.payment_type=0;
        if(this.payment > 0) {
          if(this.value.products.indexOf(this.payment)===-1) {
            this.value.products.push(this.payment);
            this.option.payment.forEach(payment=>{
              if(payment.id === parseInt(this.payment)) {
                this.value.payment_type = this.convertPayment(payment.name);
              }
            })
          }
        }
        if(this.inquiry > 0) {
          if(this.value.products.indexOf(this.inquiry)===-1) {
            this.value.products.push(this.inquiry);
            this.option.inquiry.forEach(inquiry=>{
              if(inquiry.id === parseInt(this.inquiry)) {
                this.value.inquiry_conversion_type = this.convertInquiry(inquiry.name);
              }
            })
          }
        }
        /*
        플러그인은 예외 처리
        0: 안 산다
        1: 산다
        * */
        if(this.userGrade > 0) {
          if(this.value.plugins.indexOf('user_grade') === -1) {
            this.option.plugIn.forEach(item => {
              if (item.name === '회원등급') this.value.products.push(item.id);
            })
            this.value.plugins.push('user_grade');
          }
        }
        if(this.partnerGrade > 0) {
          if(this.value.plugins.indexOf('partner_grade') === -1) {
            this.option.plugIn.forEach(item => {
              if (item.name === '파트너등급') this.value.products.push(item.id);
            })
            this.value.plugins.push('partner_grade');
          }
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-prod-box
    display flex
    align-items center
    justify-content center
    color #fff
    text-align center
    font-size 0.9rem
    background-color #ff5722
    padding 4px 10px 4px 12px
    border-radius 20px
    height 28px
    margin-left 12px

  .lp-prod-box:first-child
    margin 0

  .lp-box-delete
    font-size 12px
    margin-left 6px

</style>
